import { ChangeDetectionStrategy, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Roulette } from 'app/public/model/roulette.model';

@Component({
  selector: 'app-roulette-preview',
  templateUrl: './roulette-preview.component.html',
  styleUrls: ['./roulette-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class RoulettePreviewComponent implements OnInit {

  @Input()
  public roulette: Roulette;

  get thumbUrl() {
    return this.roulette?.Design.Spinner.ThumbUrl;
  }

  get logoSettings() {  
    return this.roulette?.Design.LogoSettings;
  }
  get logoUrl() {
    let newLogo = (this.logoSettings as any).newLogoImageAsBase64;
    return newLogo ? newLogo : this.logoSettings.LogoUrl;
  }

  constructor() { }

  ngOnInit(): void {
  }



}
